(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const observerOptions = { root: null, threshold: 0.1 };
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const animatedElements = entry.target.querySelectorAll('[class*="lg-animate-"]');
          animatedElements.forEach(el => el.classList.add('is-visible'));
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    document.querySelectorAll('[class*="lg-observer-trigger-"]').forEach(trigger => {
      observer.observe(trigger);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nigamo"] && !Shopify.designMode) return;
  try {
    
  const initNigamoAnimation = () => {
    const sections = document.querySelectorAll('[class^="ai-portrait-cards-"]');
    
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -80px 0px', 
      threshold: 0.30 
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const cards = entry.target.querySelectorAll('[class^="ai-portrait-card-"]');
          cards.forEach((card, index) => {
            card.style.transitionDelay = `${index * 150}ms`;
            card.classList.add('is-visible');
          });
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    sections.forEach(section => observer.observe(section));
  };

  initNigamoAnimation();

  document.addEventListener('shopify:section:load', () => {
    initNigamoAnimation();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-section"] && !Shopify.designMode) return;
  try {
    
  const initSplitLayoutAnimation = () => {
    const items = document.querySelectorAll('[class*="animate-item-"]');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const item = entry.target;
          const delay = item.getAttribute('data-delay') || 0;
          setTimeout(() => { item.classList.add('is-visible'); }, delay);
          observer.unobserve(item);
        }
      });
    }, { threshold: 0.15 });
    items.forEach(item => observer.observe(item));
  };
  initSplitLayoutAnimation();
  document.addEventListener('shopify:section:load', () => { initSplitLayoutAnimation(); });

  } catch(e) { console.error(e); }
})();
})();
